import React, { FC, useMemo } from 'react';
import { Button, Card, Col } from 'reactstrap';
import { ProductModel } from '../../shared/orders';
import { RaffleWithUserDetails } from '../../shared/orders/raffle';
import { Theme } from '../services';
import { useTranslation } from '../translations';
import { displayName, usePreferences } from '../utils';
import { BuyButton, ProductPrice } from '../utils/product';
import { RichMarkdownIt } from '.';
interface RegTypeSelectProps {
  readonly product: ProductModel;
  readonly isSelected?: boolean;
  readonly isPaid?: boolean;
  readonly raffle?: RaffleWithUserDetails;
  readonly onSelect: (productId: number) => void;
}

export const RegTypeSelect: FC<RegTypeSelectProps> = ({
  isSelected,
  isPaid,
  onSelect,
  product,
  raffle,
}) => {
  const { ts } = useTranslation();
  const { theme } = usePreferences()!;
  const lightMode = useMemo(() => theme === Theme.Light, [theme]);
  return (
    <Col
      className="mb-10"
      id={`product${product.id}`}
      key={`${product.id}-${product.category.id}`}
      lg={6}
      xs={12}
    >
      <Card className="productItem markdown-container">
        <div className="productInfo">
          <h5>{displayName(product)}</h5>
          <RichMarkdownIt source={product.description ?? ts('common.no_description_provided')} />
        </div>
        <div className="productPurchaseBar">
          {!isSelected && !isPaid && <ProductPrice product={product} />}
          {isSelected || isPaid ? (
            <Button
              className={isSelected ? 'continue' : 'cancelUpgrade'}
              color={isSelected ? (lightMode ? 'secondary' : 'light') : 'warning'}
              id={`selectProduct${product.id}`}
              onClick={() => {
                onSelect(product.id);
              }}
              outline
            >
              {ts(isSelected ? 'common.continue' : 'cancel_upgrade')}
            </Button>
          ) : (
            <BuyButton
              label={ts('common.select')}
              onSelect={onSelect}
              product={product}
              raffle={raffle}
            />
          )}
        </div>
      </Card>
    </Col>
  );
};
